// @ts-ignore

import { Button, Box } from "@mui/material";
import ButtonGroup from "@mui/material/ButtonGroup";
import InfoIcon from "@mui/icons-material/Info";
import MoodIcon from "@mui/icons-material/Mood";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { useEffect, useState } from "react";

type Props = {
  options: {
    label: string;
    disabled: boolean;
    isSelected: boolean;
    onClick: (view: any) => void;
  }[];
};

const ContestFooter: React.FC<Props> = ({ options = [] }) => {
  const [mobileView, setMobileView] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setMobileView(window.innerWidth <= 500);
    };
    handleResize();

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (!mobileView) {
    return null;
  }
  if (!options.length) {
    return null;
  }
  return (
    <Box
      sx={{
        backgroundColor: "#ffe263",
        position: "fixed",
        bottom: 0,
        width: "100%",
        padding: "0px 0",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        zIndex: 9999
      }}
    >
      <ButtonGroup
        variant="contained"
        aria-label="Basic button group"
        fullWidth
        disableElevation
        sx={{ textAlign: "center" }}
      >
        {options.map((option) => {
          return (
            <Button
              key={option.label}
              fullWidth
              sx={{
                background: option.isSelected ? "#1976d2" : "#ffe263",
                color: option.isSelected ? "#f5f5f5" : "#245c9c"
              }}
              onClick={() =>
                option.onClick ? option.onClick(option.label) : null
              }
              disabled={option.disabled}
              aria-selected={option.isSelected}
              endIcon={getIconByLabel(option.label)}
            >
              {option.label}
            </Button>
          );
        })}
      </ButtonGroup>
    </Box>
  );
};

export default ContestFooter;

const getIconByLabel = (label: string) => {
  switch (label) {
    case "info":
      return <InfoIcon />;
    case "submit":
      return <CloudUploadIcon />;
    default:
      return <MoodIcon />;
  }
};
